

import React, { useState, useCallback } from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  MenuItem, 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';

const ConditionalLogicModal = ({
  open,
  onClose,
  onSave,
  initialValues = { condLogic: '', condexp: '' }
}) => {
  const [values, setValues] = useState(initialValues);

  const handleCondLogicChange = useCallback((e) => {
    setValues(prev => ({ ...prev, condLogic: e.target.value }));
  }, []);

  const handleCondExpChange = useCallback((e) => {
    const value = e.target.value;
    if (value.length <= 1000) {
      setValues(prev => ({ ...prev, condexp: value }));
    }
  }, []);

  const handleSave = useCallback(() => {
    onSave(values);
    onClose();
  }, [values, onSave, onClose]);

  const handleCancel = useCallback(() => {
    setValues(initialValues);
    onClose();
  }, [initialValues, onClose]);

  return (
    <Dialog 
      open={open} 
      onClose={handleCancel}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Set Conditional Logic for Selected Test Steps</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 2, pt: 1 }}>
          <TextField
            select
            fullWidth
            label="Condition Logic"
            value={values.condLogic}
            onChange={handleCondLogicChange}
            InputLabelProps={{
              shrink: true
            }}
          >
            <MenuItem value="if-true">If-True</MenuItem>
            <MenuItem value="if-false">If-False</MenuItem>
          </TextField>

          <TextField
            fullWidth
            label="Condition Expression"
            multiline
            rows={4}
            value={values.condexp}
            onChange={handleCondExpChange}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              maxLength: 1000
            }}
            placeholder="Enter condition expression (max 1000 characters)"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ color: "#ff5336" }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{ background: "#ff5336" }}
          onClick={handleSave}
          disabled={!values.condLogic || !values.condexp}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConditionalLogicModal;